import React from 'react';
import { useAuth } from '../providers/AuthProvider';
export function FeatureWrapper(props) {
    var children = props.children, featureKey = props.featureKey;
    var user = useAuth().user;
    return React.createElement(React.Fragment, null, !!(user === null || user === void 0 ? void 0 : user.features[featureKey]) && children);
}
